import { useMutation } from "react-query"

import axios from "axios"

// only for development reasons
// import success from "./__fixtures__/customer-success.json"
import {
  SignUpPostProps,
  SignUpPostMutateProps,
  Customer,
  ServiceFailedToReturn,
  FailureMessage,
} from "./types"
import { customerBaseApi, signUpPostPath, prepareSignUpBody } from "./utils"

// ================= Sign up a customer (buyer)

export const useSignUpPost = ({ onSuccess }: SignUpPostProps) => {
  const postData = async ({
    customerInfo,
    orgUuid,
    purchaseUuid,
  }: SignUpPostMutateProps) => {
    try {
      // only for development reasons
      // if (process.env.NODE_ENV === "development") {
      //   return success
      // }
      const { data } = await axios.post(
        customerBaseApi(signUpPostPath(orgUuid)),
        prepareSignUpBody(purchaseUuid, customerInfo),
        {
          headers: {
            "Content-Type": "application/json",
          },
          validateStatus: (status: number) => status === 201,
        },
      )

      return data
    } catch (err: any) {
      const { status } = err.response || {}
      let failureMessage

      switch (status) {
        case 400:
          failureMessage = FailureMessage.INVALID_INPUT
          break
        case 409:
          failureMessage = FailureMessage.PURCHASE_ALREADY_ASSOCIATED
          break
        case 412:
          failureMessage = FailureMessage.EMAIL_OR_PHONE_ALREADY_EXISTS
          break
        default:
          failureMessage = FailureMessage.OPERATION_ERROR
          break
      }
      return {
        failureMessage,
      }
    }
  }

  return useMutation<
    Customer & ServiceFailedToReturn,
    { message: string },
    SignUpPostMutateProps
  >(postData, { onSuccess })
}
